import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "content", "indicator"]
  static values = {
    activeTab: String
  }

  connect() {
    // URLからtabパラメータを取得
    const urlParams = new URLSearchParams(window.location.search)
    const tabParam = urlParams.get('tab')

    // tabパラメータがある場合はその値を、なければデフォルト値かactiveTabValueを使用
    const initialTab = tabParam || this.activeTabValue || this.defaultTab
    this.showTab(initialTab)

    // 初期状態でインジケーターが表示されない問題を解決するため、
    // 少し遅延させてインジケーターの位置を設定
    setTimeout(() => {
      this.updateIndicator(initialTab)
    }, 100)
  }

  // デフォルトのタブを取得（最初のタブをデフォルトとする）
  get defaultTab() {
    return this.hasTabTarget ? this.tabTargets[0].dataset.tab : "fresh"
  }

  switch(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    this.showTab(tab)

    // タブパラメータをURLに反映（オプション）
    const url = new URL(window.location)
    url.searchParams.set('tab', tab)
    window.history.pushState({}, '', url)
  }

  showTab(tab) {
    // タブの表示/非表示を切り替え
    this.contentTargets.forEach(content => {
      content.classList.toggle('hidden', content.dataset.tab !== tab)
    })

    // インジケーターの更新
    this.updateIndicator(tab)

    // アクティブクラスの切り替え
    this.tabTargets.forEach(t => {
      t.classList.toggle('text-white', t.dataset.tab === tab)
      t.classList.toggle('text-gray-400', t.dataset.tab !== tab)
    })
  }

  updateIndicator(tab) {
    // アクティブタブを探す
    const activeTab = this.tabTargets.find(t => t.dataset.tab === tab)
    if (!activeTab || !this.hasIndicatorTarget) return

    // tabs-wrapper を基準とした位置計算
    const tabsWrapper = activeTab.closest('.tabs-wrapper')
    if (!tabsWrapper) return

    const wrapperRect = tabsWrapper.getBoundingClientRect()
    const activeRect = activeTab.getBoundingClientRect()

    // インジケーターの位置とサイズを設定
    this.indicatorTarget.style.transform = `translateX(${activeRect.left - wrapperRect.left}px)`
    this.indicatorTarget.style.width = `${activeRect.width}px`
  }
}